module.exports = "/static/assets/312362fef257216b1c6fd788237d3831.png";